import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { setIncludeLevelLower } from 'reducers/monitorsAndAlerts/reducer'
import messages from '../translate'

class Summary extends Component {
  getSummaryStatus = () => {
    const {
      intl: { formatMessage },
      data,
    } = this.props
    const summary = data.get('summary').criticality_levels
    const result = []

    // Temporary solution, I don't like it so much
    for (const key in summary) {
      if (Object.prototype.hasOwnProperty.call(summary, key)) {
        const status = key.slice(28)

        result.push(
          <li
            key={key}
            className={cn('status-item', {
              [status.split('_').join('-')]: key,
            })}>
            <span className="count">{summary[key]}</span>
            <span className="type">{formatMessage({ id: key })}</span>
          </li>,
        )
      }
    }

    return result
  }

  render() {
    const {
      intl: { formatMessage },
      showIncludeLevelLowerCheckbox,
      setIncludeLevelLower,
      includeLevelLower,
    } = this.props

    return (
      <div className="ma-summary">
        <ul className="status-bar">{this.getSummaryStatus()}</ul>
        {showIncludeLevelLowerCheckbox && (
          <FormControlLabel
            control={
              <Checkbox
                href={null}
                checked={includeLevelLower}
                onChange={() => setIncludeLevelLower(!includeLevelLower)}
                name="checkedB"
                color="primary"
              />
            }
            label={formatMessage(messages.includeIndicatorsLowerLevel)}
          />
        )}
      </div>
    )
  }
}

export default connect(
  state => ({
    data: state.getIn(['monitorsAndAlerts', 'data']),
    profile: state.getIn(['profile', 'profile']),
    roleLevel: state.getIn(['profile', 'roleLevel']),
    includeLevelLower: state.getIn(['monitorsAndAlerts', 'includeLevelLower']),
    showIncludeLevelLowerCheckbox: state.getIn([
      'monitorsAndAlerts',
      'showIncludeLevelLowerCheckbox',
    ]),
  }),
  {
    setIncludeLevelLower,
  },
)(injectIntl(Summary))
